import type { AuthFeaturedProduct } from '../constants/auth-landing.constants';

interface AuthProductsPanelProps {
  products: AuthFeaturedProduct[];
  quoteUrl: string;
  quoteLabel: string;
  className?: string;
}

export function AuthProductsPanel({
  products,
  quoteUrl,
  quoteLabel,
  className = '',
}: AuthProductsPanelProps) {
  return (
    <section
      className={`flex flex-col items-stretch gap-5 px-[clamp(12px,1.5vw,16px)] pt-[clamp(24px,4vw,60px)] pb-[clamp(12px,3vw,32px)] text-white min-[900px]:max-w-[780px] min-[900px]:items-start min-[900px]:px-[clamp(20px,4vw,72px)] ${className}`}
    >
      <ul className='flex flex-wrap justify-around gap-x-[clamp(16px,3vw,44px)] gap-y-4 rounded-[14px] border-2 border-[#00a651] px-[clamp(18px,2.5vw,32px)] py-[clamp(16px,2vw,24px)] min-[900px]:justify-start'>
        {products.map(product => (
          <li key={product.title} className='flex items-center gap-4'>
            <img
              src={product.icon}
              alt=''
              aria-hidden='true'
              className='block h-[clamp(40px,3.6vw,54px)] w-auto'
            />
            <p className='text-[clamp(15px,1.35vw,20px)] font-bold leading-[1.2]'>
              {product.title}
              <br />
              {product.subtitle}
            </p>
          </li>
        ))}
      </ul>

      <p className='text-center text-[clamp(15px,1.3vw,20px)] italic leading-[1.4] min-[900px]:text-left'>
        Para cotar estes seguros, clique no botão abaixo.
      </p>

      <a
        href={quoteUrl}
        target='_blank'
        rel='noopener noreferrer'
        className='rounded-[10px] bg-[#00a651] px-[26px] py-3.5 text-center text-[clamp(15px,1.2vw,19px)] font-bold text-white transition-colors hover:bg-[#008f45] active:bg-[#007a3b] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white'
      >
        {quoteLabel}
      </a>
    </section>
  );
}
